import Cookies from "js-cookie";

const state = {
  config: null,
  loggedIn: false,
  user: null,
  accessToken: null,
  isVideoInHomeSubdomain: false,
  currentApp: "video-in-home", // Default to broadcast app
  maintenanceStatus: false
};

const getters = {
  getConfig: state => state.config,
  getLoggedIn: state => state.loggedIn,
  getUser: state => state.user,
  getAccessToken: state => state.accessToken,
  getIsVideoInHomeSubdomain: state => state.isVideoInHomeSubdomain,
  getCurrentApp: state => state.currentApp,
  getMaintenanceStatus: state => state.maintenanceStatus
};

const mutations = {
  setConfig: (state, payload) => (state.config = payload),
  setLoggedIn: (state, payload) => (state.loggedIn = payload),
  setUser: (state, payload) => (state.user = payload),
  setAccessToken: (state, payload) => (state.accessToken = payload),
  setIsVideoInHomeSubdomain: (state, payload) => {
    state.isVideoInHomeSubdomain = payload;
  },
  setCurrentApp: (state, payload) => {
    state.currentApp = payload;
  },
  setMaintenanceStatus: (state, payload) => {
    state.maintenanceStatus = payload;
  }
};

const actions = {
  async loadConfig({ state }) {
    // Config is already loaded via main.js; no-op.
  },
  login({ commit }, payload) {
    const token = payload.token;
    const username = payload.authenticationStatus.user.username;
    localStorage.setItem("accessToken", token);
    localStorage.setItem("user", username);

    commit("setUser", username);
    commit("setAccessToken", token);
    commit("setLoggedIn", true);
  },
  async logout({ commit, state, dispatch }) {
    await dispatch("loadConfig");
    localStorage.removeItem("accessToken");
    localStorage.removeItem("user");
    Cookies.remove("WebservicesJwt", {
      domain: state.config.AuthCookieDomain,
      path: "/",
      secure: true
    });
    Cookies.remove("User", { domain: state.config.AuthCookieDomain });
    await commit("setUser", null);
    await commit("setAccessToken", null);
    await commit("setLoggedIn", false);
  },
  determineVideoInHomeSubdomain({ commit }) {
    const currentHostname = window.location.hostname;
    // Simple check for development and testing
    const isVideoInHome = currentHostname.includes("videoinhome");
    commit("setIsVideoInHomeSubdomain", isVideoInHome);

    // Set current app based on subdomain
    if (isVideoInHome) {
      commit("setCurrentApp", "video-in-home");
    } else {
      commit("setCurrentApp", "broadcast");
    }

    return isVideoInHome;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
